import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import {
  Row, Col,
} from "reactstrap";

import StatisticData from '../managementTables/statisticData'
import Report5nested from './Report5nested'
import Report4nested from './Report4nested'
import {connect} from 'react-redux'
import {getCode4Nested} from 'actions/reportActions';
import * as XLSX from 'xlsx';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import { saveAs } from 'file-saver';
import ReportButtons from 'components/common/ReportButtons'


const Report4 = (props) => {
  const { tableData, showOPK, showOPKtoggle, refresh, parameters, getCode4Nested, nestedLoading, title} = props
  const [refreshNested, setRefreshNested] = React.useState(false)
  React.useEffect(() => {
    setRefreshNested(!refreshNested)
  }, [nestedLoading])
  const canBeToggled = ['dir_cost', 'koszt_dzial_medycz', 'koszt_dzial_niemedycz', 'procedural_cost','manag_cost']// 
  let temp = {}
  canBeToggled.forEach((no) => temp[no] = {})//empty {} for each report
  const [showOPKnested, setShowOPKnested] = React.useState(temp)
  // const [dividerForNested, setDividerForNested] = React.useState(null)

  const valueConvert = (val, prec=2) => {
    let nr = Number(val).toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return nr==="NaN" ? "X": nr
  }

  const getMeanValue = (cost, divider) => {
    if(divider==0) return 'X'
    else{
      return valueConvert(cost/divider)//=='0,00'?'X':valueConvert(cost/dividerForNested)
    }
  }
  
  if(tableData&&Object.getOwnPropertyNames(tableData).length){
    let statsRows =[],
      kosztyHeader = [], kosztyCol = [], kosztyRows ={
        'Razem koszty bezpośrednie':'dir_cost', 
        'Razem koszty działalności pomocniczej medycznej': 'koszt_dzial_medycz',
        'Razem koszty działalności pomocniczej niemedycznej': 'koszt_dzial_niemedycz', 
        'Razem koszty OPK proceduralnych': 'procedural_cost', 
        'Koszt wytworzenia OPK': 'koszt_wytworzenia', 
        'Koszt zarządu': 'manag_cost',
        'Koszt własny sprzedaży OPK': 'calkowity', 
        'Przychód całkowity OPK': 'przychod_calkowity',
        'Zysk/strata': 'zysk_strata'
      },
      rodzajRows = {
        'Koszty stałe OPK': 'koszty_stale_opk',
        'Koszty zmienne OPK': 'koszty_zmienne_opk',
        'Koszt własny sprzedaży OPK': 'calkowity'
      },
    statsData=[]
    let mainCode = tableData.code.split('-')[0]
    let dividerForNested = null
    switch(mainCode){
      case '500':
      case '501':
        kosztyHeader = ['Rodzaj kosztu', 'Wartość kosztu [zł]', 'Średniomiesięcznie [zł]', 'Udział w koszcie całkowitym OPK',
          'Średni jednostkowy koszt porady [zł]']
        kosztyCol =['', '_sredniomiesiecznie', '_p', '_koszt_porady']
        statsRows =['Liczba wykonanych porad']
        dividerForNested = tableData['Liczba wykonanych porad']
        break;
      case '504':
        kosztyHeader = ['Rodzaj kosztu', 'Wartość kosztu [zł]', 'Średniomiesięcznie [zł]', 'Udział w koszcie całkowitym OPK',
          'Średni jednostkowy koszt hospitalizowanego [zł]', 'Średni jednostkowy koszt całkowity osobodnia [zł]']
        kosztyCol =['', '_sredniomiesiecznie', '_p', '_jedn_hosp', '_jedn_osob']
        statsRows = ["Liczba łóżek","Liczba hospitalizowanych pacjentów","Liczba wykonanych osobodni","% wykorzystania łóżek","Średni czas pobytu w dniach"]
        dividerForNested = tableData['Liczba wykonanych osobodni']
        break;
      case '507':
        kosztyHeader = ['Rodzaj kosztu', 'Wartość kosztu [zł]', 'Średniomiesięcznie [zł]', 'Udział w koszcie całkowitym OPK']
        kosztyCol =['', '_sredniomiesiecznie', '_p']
        statsRows = ['Liczba wykonanych procedur medycznych']
        break;
      case '530':
      case '535':
        kosztyHeader = ['Rodzaj kosztu', 'Wartość kosztu [zł]', 'Średniomiesięcznie [zł]', 'Udział w koszcie całkowitym OPK']
        kosztyCol =['', '_sredniomiesiecznie', '_p']
        statsRows = ['Liczba wykonanych usług']
        break;
      default:
        break
    }
    const checkZyskStrata = (name, value) =>{
      console.log(name)
      if(name==='zysk_strata'&&value){
        return value<0?{color:'#eb6b6b', fontWeight: 'bold'}:{color:'#00b882', fontWeight: 'bold'}
      }else if(name=='calkowity'||name=='przychod_calkowity'){
        return {fontWeight: 'bold'}
      }
      return {}
    }

    const showOPKnestedtoggle = (opk, active) => {
        let temp = showOPKnested
        if (showOPKnested[active][opk] !== undefined) { //if that opk was clicked before, toggle view on that row
            temp[active][opk] = !showOPKnested[active][opk]
            setShowOPKnested(temp)
            setRefreshNested(!refreshNested)
        } else { //first time for that opk -> get children from API
            let params = parameters
            params.number = opk
            
            switch (active) {
                case 'dir_cost':
                  getCode4Nested(active, params)
                  break;
                default:
                    return 0
            }
            temp[active][opk] = true
            setShowOPKnested(temp)
            setRefreshNested(!refreshNested)
        }
    }
    const downloadXlsx = () =>{
      var wb = XLSX.utils.table_to_book(document.getElementById('tabela4'), {sheet:"tabela 1", raw:true});

      wb.SheetNames.push("tabela 2");
      var ws2 = XLSX.utils.table_to_sheet(document.getElementById('tabela41'), {raw:true});
      wb.Sheets["tabela 2"] = ws2;

      wb.SheetNames.push("tabela 3");
      var ws2 = XLSX.utils.table_to_sheet(document.getElementById('statistic'), {raw:true});
      wb.Sheets["tabela 3"] = ws2;

      var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
      let filename = title + '.xlsx';
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
    }
    const s2ab = (s)=>{
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    const downloadCSV = () =>{
      let filename = title+'.csv';
      // var tableSelect = document.getElementById('#procedura')
      // var tableHTML = tableSelect.outerHTML;
      var csv = [];
      var csv2 = [];
      var csv3 = [];
      var rows = document.querySelectorAll(`#tabela4 tr`);
      var rows2 = document.querySelectorAll(`#tabela41 tr`);
      var rows3 = document.querySelectorAll(`#statistic tr`);
      for (var i = 0; i < rows.length ; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");
          for (var j = 0; j < cols.length; j++) 
              row.push(cols[j].innerText);
              
          csv.push(row.join(";"));		}
          csv.push("")
          csv.push("")
      for (var i = 0; i < rows2.length; i++) {
        var row2 = [], cols2 = rows2[i].querySelectorAll("td, th");
        for (var j = 0; j < cols2.length; j++) 
            row2.push(cols2[j].innerText);
        
        csv2.push(row2.join(";"));		}
        csv2.push("")
        csv2.push("")
        for (var i = 0; i < rows3.length; i++) {
          var row3 = [], cols3 = rows3[i].querySelectorAll("td, th");
          for (var j = 0; j < cols3.length; j++) 
              row3.push(cols3[j].innerText);
          
          csv3.push(row3.join(";"));		}
      csv = csv.join("\n")
      csv2 = csv2.join("\n")
      csv3 = csv3.join("\n")
  
      var csvFile;
      var downloadLink;
      // CSV FILE
      var universalBOM = "\uFEFF";
      csvFile = new Blob(['\ufeff',csv, csv2, csv3], {type: "text/csv;charset=UTF-8"});
      // Download link
      downloadLink = document.createElement("a");
      // File name
      downloadLink.download = filename;
      // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
      // Make sure that the link is not displayed
      downloadLink.style.display = "none";
      // Add the link to your DOM
      document.body.appendChild(downloadLink);
      // Lanzamos
      downloadLink.click();
  }
    
  //DOC
  const getTableRow = (values, format={}, mergeCells={col:[], row: []}) => {
    let row = []
    let zyskStrataStyle = {}
    if(values[0]==='Zysk/strata'){
      zyskStrataStyle = {
        '1':Number(values[1].replace(',','.').replaceAll(' ', ''))<0?'#eb6b6b':'#00b882',
        '2':Number(values[2].replace(',','.').replaceAll(' ', ''))<0?'#eb6b6b':'#00b882'
      }
    } 

    let boldRow = ['Zysk/strata','Przychód całkowity OPK','Koszt własny sprzedaży OPK'].includes(values[0])

    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold||(format.firstBold&&i===0)||boldRow, 
              color: zyskStrataStyle[i]!==undefined?zyskStrataStyle[i]:format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        rowSpan: mergeCells.row[i]?mergeCells.row[i]:1,
        columnSpan: mergeCells.col[i]?mergeCells.col[i]:1,
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    let divider = dividerForNested
    let statParagraph = [], temp
    statsRows.forEach((item, i) => {
      temp = (item === '% wykorzystania łóżek'||item === 'Średni czas pobytu w dniach')?valueConvert(tableData[item]):valueConvert(tableData[item], 0)
      if(item === '% wykorzystania łóżek') temp+='%'
      statParagraph.push(new TextRun({text: '', break:1, size: 24 }))
      statParagraph.push(new TextRun({text: item+': ', font:'Calibri', bold: true, size: 24 }))
      statParagraph.push(new TextRun({text: temp, font:'Calibri', bold: false, size: 24 }))
    })

    //TABLE
    let rows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(kosztyHeader.length).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: [AlignmentType.LEFT].concat(Array(kosztyHeader.length-1).fill(AlignmentType.RIGHT))
    }
    const nestedHeaderStyle = {
      bold: true, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
      align: Array(6).fill([AlignmentType.CENTER])
    }
    const nestedStyle = {
      bold: false, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill([AlignmentType.LEFT]).concat(Array(4).fill(AlignmentType.RIGHT))
    }

    // header
    rows.push(new TableRow({
      children: getTableRow(kosztyHeader, headerStyle, {col:[2,1,1,1,1], row: []}),
      tableHeader: true
    }))
    
    //body
    let tempRow
    Object.entries(kosztyRows).map(([rowTitle, rowVar]) => {
      tempRow = [rowTitle].concat(
        kosztyCol.map(colVar => {
          temp = valueConvert(tableData[rowVar+colVar])
          if(colVar.includes(colVar !=="_koszt_porady"?'_p':'skipThat') && valueConvert(tableData[rowVar+colVar]) !=="X") temp+='%'
          return temp
        })
      )
      rows.push(new TableRow({
        children: getTableRow(tempRow, {...bodyStyle, firstBold: true}, {col:[2,1,1,1,1], row: []})
      }))
      
      //nested table
      if(showOPK[rowVar]){
        if(rowVar==='dir_cost'){
          //header
          // rows.push(new TableRow({
          //   children: getTableRow(
          //     ['Numer konta zespołu 4','Nazwa konta zespołu 4', 'Wartość kosztu [zł]','Udział w koszcie całkowitym OPK'],
          //     nestedHeaderStyle,
          //     {col:[1,2,1,1], row: []}
          //   )
          // }))
          //body
          Object.entries(tableData.nested[rowVar]).map(([opk, item], i) => {
            tempRow = [
              opk,
              item.name,
              valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']),
              valueConvert(item['sredniomiesiecznie']),
              valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%'
            ]
            if(divider!==null){
              tempRow = tempRow.concat([getMeanValue(item['WARTOŚĆ KOSZTU [ZŁ]'], divider)])
            }
            rows.push(new TableRow({
              children: getTableRow(tempRow, nestedStyle)
            }))
            //nested
            if(item['children']!==undefined && showOPKnested[rowVar][opk]){
              Object.entries(item['children']).map(([opk2, item2]) => {
                tempRow = [
                  opk2,
                  item2.name,
                  valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]']),
                  valueConvert(item2['sredniomiesiecznie']),
                  valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%'
                ]
                if(divider!==null){
                  tempRow = tempRow.concat([getMeanValue(item2['WARTOŚĆ KOSZTU [ZŁ]'], divider)])
                }
                rows.push(new TableRow({
                  children: getTableRow(tempRow, nestedStyle)
                }))
              })
            }
          })
        }else{
            //header
            // rows.push(new TableRow({
            //   children: getTableRow(
            //     ['Konto zespołu 5 - Ośrodki zlecające numer konta','Nazwa OPK', 'Liczba wykonanych procedur/usług','Koszt wykonanych procedur/usług [zł]', 'Udział w koszcie całkowitym OPK'],
            //     nestedHeaderStyle,
            //   )
            // }))
            //body
            tableData.nested[rowVar].forEach((item) => {
              tempRow = [
                  item.code,
                  item.name,
                  valueConvert(item.koszt),
                  valueConvert(item.sredniomiesiecznie),
                  valueConvert(item.koszt_proc)+'%'
                ]
                if(divider!==null){
                  tempRow = tempRow.concat([getMeanValue(item.koszt, divider)])
                }
              rows.push(new TableRow({
                children: getTableRow(tempRow, nestedStyle)
              }))
            })
        }
      }
    })
    rows.push(new TableRow({
      children: getTableRow([
        'Procent pokrycia kosztów przychodami',
        valueConvert(tableData['procent_pokrycia'])+'%'
      ], {...bodyStyle, bold: true}, {col:[2,4], row: []})
    }))

    let table = new Table({
      rows: rows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //second table
    rows = []
    rows.push(new TableRow({
      children: getTableRow([
        'Rodzaj kosztu',
        'Wartość [zł]',
        'Udział w koszcie całkowitym OPK'
      ], headerStyle),
      tableHeader: true
    }))
    Object.entries(rodzajRows).map(([rowTitle, rowVar]) => {
      rows.push(new TableRow({
        children: getTableRow([
          rowTitle,
          valueConvert(tableData[rowVar]),
          valueConvert(tableData[rowVar+'_p'])+'%'
        ], rowTitle==='Koszt własny sprzedaży OPK'?{...bodyStyle, bold: true}:bodyStyle)
      }))
      return 0
    })
    let table2 = new Table({
      rows: rows,
      width: { size: 80, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      new Paragraph({
        children: statParagraph,
        alignment: AlignmentType.LEFT,
        spacing: { after: 200 },
        indent: {left:5000}
      }),
      table,
      new Paragraph({
        children: [],
        spacing: { after: 200 },
      }),
      table2
    ]

    let doc = new Document({ 
        sections: [{
            properties: { page: { 
                size: { 
                    // height: convertMillimetersToTwip(210),
                    // width: convertMillimetersToTwip(297) 
                },
                margin: {
                    top: convertMillimetersToTwip(15),
                    right: convertMillimetersToTwip(15),
                    bottom: convertMillimetersToTwip(15),
                    left: convertMillimetersToTwip(15),
                },
            }},
            children: paragraphs
        }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();

    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }

    return (<>
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} />

      <Row>
        <Col md='8'></Col>
        <Col md='4'>
          <StatisticData tableData={tableData} opk={tableData.code} />
        </Col>
      </Row>

      <table className='table table-border tableRaporty' id="tabela4">
        <thead className="headerColor">
          <tr>
            {kosztyHeader.map((colTitle, i) => {
              return <th key={'thead'+i} colSpan={i==0?'2':'1'}>{colTitle}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {Object.entries(kosztyRows).map(([rowTitle, rowVar], ind) => {
            return (<>
              <tr key={'tableRow'+ind} className='tryColor'>
                {canBeToggled.includes(rowVar)?
                  <td className='tdTitles' onClick={()=>showOPKtoggle(rowVar)} style={{cursor: 'pointer'}} colSpan='2'> 
                    {showOPK[rowVar]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>:<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                    {rowTitle}
                  </td>:
                  <td className='tdTitles' colSpan='2'> {rowTitle} </td>
                }
                {kosztyCol.map((colVar, i) => {
                  return <td key={'tableCell'+ind+'-'+i} className='rightAlignCell' style={checkZyskStrata(rowVar, tableData[rowVar+colVar])}>
                    {valueConvert(tableData[rowVar+colVar])}{colVar.includes(colVar !=="_koszt_porady" ?'_p': "we dont need no _p here") && valueConvert(tableData[rowVar+colVar]) !=="X" ?<>%</>:<></>}</td>
                })}
              </tr>
              {/* NESTED */}
              {tableData.nested[rowVar]!==undefined && showOPK[rowVar]&&<>
                  {rowVar==='dir_cost'? <>
                    {Object.getOwnPropertyNames(tableData.nested[rowVar]).length===0?
                      <tr><td colSpan='6'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                      <Report5nested 
                        tableData={tableData.nested[rowVar]} 
                        showOPK={showOPKnested[rowVar]} showOPKtoggle={(opk)=>{showOPKnestedtoggle(opk, rowVar)}} 
                        dividerForNested={dividerForNested} refresh={refreshNested} />
                    }</>
                  : <>
                    {tableData.nested[rowVar].length===0?
                      <tr><td colSpan='6'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                      <Report4nested tableData={tableData.nested[rowVar]} refresh={refresh} dividerForNested={dividerForNested}/>
                    }</>
                  }    
              </>}
            </>)
          })}
          <tr className="tryColor tdTitles">
            <td className='' colSpan='2'>Procent pokrycia kosztów przychodami</td>
            <td className='rightAlignCell' colSpan='4' >{valueConvert(tableData['procent_pokrycia'])}%</td>
          </tr>
        </tbody>
      </table>

      <Row>
        <Col md='7'>
          <table className='table table-border tableRaporty' id='tabela41'>
            <thead className="headerColor">
              <tr>
                <th>Rodzaj kosztu</th>
                <th>Wartość [zł]</th>
                <th>Udział w koszcie całkowitym OPK</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(rodzajRows).map(([rowTitle, rowVar], ind) => {
                return (<tr key={'tableRow'+ind} className={ind===2?"tryColor tdTitles":"tryColor"}>
                  <td className=''>{rowTitle}</td>
                  <td className='rightAlignCell'>{valueConvert(tableData[rowVar])}</td>
                  <td style={{width:"20%"}} className='rightAlignCell'>{valueConvert(tableData[rowVar+'_p'])}%</td>
                </tr>)
              })}
            </tbody>
          </table>
        </Col>
        <Col md='5'></Col>
      </Row>
    </>)
  }else{
    return <Spinner />
  }
}
Report4.propTypes = {
  tableData: PropTypes.object,
  showOPK: PropTypes.object,
  showOPKtoggle: PropTypes.func,
  refresh: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  nestedLoading: state.reportReducer.nestedLoading,
})

export default connect(mapStateToProps, {getCode4Nested})(Report4)
